<template>
  <!--分包商报价明细-->
  <div class="table-box">
    <div class="pack-file-box">
      <div
        v-if="this.tableTopBtn && this.tableTopBtn.length > 0"
        class="pack-tabbox"
      >
        <el-button
          v-for="(item, index) in tableTopBtn"
          :key="index"
          @click="tableTopChangeSupply(item.value)"
          size="mini"
          type="text"
          :class="
            'pack-tabbox-btn' + (isFocus == item.value ? ' pack-active' : '')
          "
          ><span class="table_topbtn" :title="item.label">{{
            item.label
          }}</span>
          <span v-if="item.packStatusStr" class="packStatus_btn">{{
            item.packStatusStr
          }}</span></el-button
        >
      </div>
      <div class="iframe_topbox" v-loading="fullscreenLoading">
        <h3 class="table-three-box-title clearfix">
          <span
            class="table-three-box-title-btn"
            :title="packName ? packName + '包件报价一览表' : '报价一览表'"
            >{{ packName ? packName + "包件" : "" }} </span
          ><span>报价一览表</span>
        </h3>
        <iframe
          id="supplierQuoteListIframe"
          width="100%"
          height="500px"
          :src="dataHref"
          frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import { scpQueryPurchaseSchemePackageApi } from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
export default {
  name: "supplierQuoteList",
  data() {
    return {
      tableTopBtn: [],
      isFocus: "",
      dataHref: "",
      packName: "",
      fullscreenLoading: false,
      schemeId: JSON.parse(sessionStorage.getItem("expertSourceData")).schemeId
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getLoading();
      this.getPackList();
    },
    getLoading() {
      let _this = this;
      this.fullscreenLoading = true;
      this.$nextTick(() => {
        let biddingIframe = document.getElementById("supplierQuoteListIframe");
        if (biddingIframe.attachEvent) {
          biddingIframe.attachEvent("onload", function() {
            _this.fullscreenLoading = false;
          });
        } else {
          biddingIframe.onload = function() {
            _this.fullscreenLoading = false;
          };
        }
        setTimeout(function() {
          if (_this.fullscreenLoading) {
            _this.fullscreenLoading = false;
          }
        }, 3000);
      });
    },
    //分包商报价明细页签切换
    tableTopChangeSupply(value) {
      this.isFocus = value;
      this.getDataHref();
    },
    //查询分包
    getPackList() {
      let param = {
        schemeId: this.schemeId,
        pageNo: -1,
        pageSize: -1
      };
      param.isShowPageLoading = true;
      scpQueryPurchaseSchemePackageApi(param).then(res => {
        if (res.data.code === "0") {
          res.data.data.rows.forEach(item => {
            item.label = item.packName;
            item.value = item.packId;
            if (
              item.packStatus !== undefined &&
              item.packStatus !== null &&
              item.packStatus !== "" &&
              item.packStatus != 1
            ) {
              item.packStatusStr = "（已流标）";
            }
          });
          this.tableTopBtn = res.data.data.rows;
          if (this.tableTopBtn && this.tableTopBtn.length > 0) {
            this.isFocus = this.tableTopBtn[0].packId;
          }
          this.getDataHref();
        }
      });
    },
    getDataHref() {
      let href = "";
      let path = window.location.href;
      if (this.tableTopBtn && this.tableTopBtn.length > 1) {
        if (path.indexOf("uat01") != -1) {
          href =
            "https://uat01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqryPackSupQuotationDetails.cpt&ref_t=design&op=write&ref_c=8d10791b-9203-4f78-9a96-9080a9d35dd4&schemeId=";
        } else if (path.indexOf("test01") != -1) {
          href =
            "https://test01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqryPackSupQuotationDetails.cpt&ref_t=design&op=write&ref_c=8d10791b-9203-4f78-9a96-9080a9d35dd4&schemeId=";
        } else if (path.indexOf("dev01") != -1) {
          href =
            "https://dev01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqryPackSupQuotationDetails.cpt&ref_t=design&op=write&ref_c=8d10791b-9203-4f78-9a96-9080a9d35dd4&schemeId=";
        } else {
          href =
            "https://fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqryPackSupQuotationDetails.cpt&ref_t=design&op=write&ref_c=8d10791b-9203-4f78-9a96-9080a9d35dd4&schemeId=";
        }
        this.dataHref = href + this.schemeId + "&packId=" + this.isFocus;
        this.packName = this.tableTopBtn.filter(item => {
          return item.value == this.isFocus;
        })[0].label;
      } else {
        if (path.indexOf("uat01") != -1) {
          href =
            "https://uat01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqryNotPackSupQuotataionDetails.cpt&ref_t=design&op=write&ref_c=8d10791b-9203-4f78-9a96-9080a9d35dd4&schemeId=";
        } else if (path.indexOf("test01") != -1) {
          href =
            "https://test01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqryNotPackSupQuotataionDetails.cpt&ref_t=design&op=write&ref_c=8d10791b-9203-4f78-9a96-9080a9d35dd4&schemeId=";
        } else if (path.indexOf("dev01") != -1) {
          href =
            "https://dev01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqryNotPackSupQuotataionDetails.cpt&ref_t=design&op=write&ref_c=8d10791b-9203-4f78-9a96-9080a9d35dd4&schemeId=";
        } else {
          href =
            "https://fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqryNotPackSupQuotataionDetails.cpt&ref_t=design&op=write&ref_c=8d10791b-9203-4f78-9a96-9080a9d35dd4&schemeId=";
        }
        this.dataHref = href + this.schemeId;
      }
      // if (this.tableTopBtn && this.tableTopBtn.length > 1) {
      //   if (path.indexOf("uat01") != -1) {
      //     href =
      //       "http://uat01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqryPackSupQuotationDetails.cpt&ref_t=design&ref_c=574b9385-e0ac-44d5-a2ff-b78d54812377&schemeId=";
      //   } else if (path.indexOf("test01") != -1) {
      //     href =
      //       "http://dev01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp_test%252FqryPackSupQuotationDetails.cpt&ref_t=design&ref_c=35a45362-837c-4cb8-8b3c-e1de540fa091&schemeId=";
      //   } else if (path.indexOf("dev01") != -1) {
      //     href =
      //       "http://dev01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqryPackSupQuotationDetails.cpt&ref_t=design&ref_c=35a45362-837c-4cb8-8b3c-e1de540fa091&schemeId=";
      //   } else {
      //     // 生产环境
      //     href =
      //       "https://fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqryPackSupQuotationDetails.cpt&ref_t=design&ref_c=bb6a604f-577d-4d1e-a12a-0ce24dacaae5&schemeId=";
      //   }
      //   this.dataHref = href + this.schemeId + "&packId=" + this.isFocus;
      //   this.packName = this.tableTopBtn.filter(item => {
      //     return item.value == this.isFocus;
      //   })[0].label;
      // } else {
      //   if (path.indexOf("uat01") != -1) {
      //     href =
      //       "http://uat01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqryNotPackSupQuotataionDetails.cpt&ref_t=design&ref_c=574b9385-e0ac-44d5-a2ff-b78d54812377&schemeId=";
      //   } else if (path.indexOf("test01") != -1) {
      //     href =
      //       "http://dev01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp_test%252FqryNotPackSupQuotataionDetails.cpt&ref_t=design&ref_c=35a45362-837c-4cb8-8b3c-e1de540fa091&schemeId=";
      //   } else if (path.indexOf("test01") != -1) {
      //     href =
      //       "http://dev01-fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqryNotPackSupQuotataionDetails.cpt&ref_t=design&ref_c=35a45362-837c-4cb8-8b3c-e1de540fa091&schemeId=";
      //   } else {
      //     href =
      //       "https://fine-report.iccec.cn/webroot/decision/view/report?viewlet=scmc_scp%252FqryNotPackSupQuotataionDetails.cpt&ref_t=design&ref_c=09a64197-e915-44a6-bf63-d067bc21726c&schemeId=";
      //   }
      //   this.dataHref = href + this.schemeId;
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.table-box {
  margin-top: 20px;
}
.iframe_topbox {
  margin-bottom: 0px;
  /deep/ .el-loading-spinner {
    top: 20vh;
  }
}
.table-three-box-title {
  margin: 20px auto;
  text-align: center;
  span {
    vertical-align: middle;
    height: 30px;
    line-height: 30px;
    display: inline-block;
    &.table-three-box-title-btn {
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      max-width: 160px;
    }
  }
}
.pack-tabbox {
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
  border-bottom: 1px solid #eee;
  background-color: #f5f5f5;
}
.pack-file-box {
  border: 1px solid #eee;
  /deep/ .operate {
    margin-right: 20px;
  }
  /deep/ .clearfix {
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
  }
}
.pack-tabbox-btn {
  margin-right: 20px;
  color: #4a4a4a;
}
.pack-active {
  color: #0089ef;
}
.table_topbtn {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  max-width: 160px;
  vertical-align: middle;
  height: 30px;
  line-height: 30px;
}
.packStatus_btn {
  vertical-align: middle;
}
</style>
